import { render, staticRenderFns } from "./AddFundTooltip.vue?vue&type=template&id=35420612&scoped=true&"
import script from "./AddFundTooltip.vue?vue&type=script&lang=tsx&"
export * from "./AddFundTooltip.vue?vue&type=script&lang=tsx&"
import style0 from "./AddFundTooltip.vue?vue&type=style&index=0&id=35420612&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35420612",
  null
  
)

export default component.exports